<template>
    <v-container>
        <v-breadcrumbs :items="breadcrumbs" large></v-breadcrumbs>

        <v-card class="mb-10">
            <v-card-text>
                <v-form @submit.prevent="formRegister" ref="refAddProduct" lazy-validation>
                    <v-row>
                        <v-col cols="12" class="text-center">
                            Imagen principal *
                            <div style="position: relative; width:250px" class="mb-6 mx-auto">
                                <v-img
                                    :src="previewImg"
                                    height="150"
                                    style="background-color: grey"
                                ></v-img>
                                <v-btn
                                    absolute
                                    dark
                                    fab
                                    bottom
                                    right
                                    @click="openInputFile"
                                >
                                    <v-icon>mdi-image</v-icon>
                                </v-btn>
                                <input type="file" @change="upBanner" class="d-none" ref="fileInput" accept="image/png, image/jpeg">
                            </div>
                            <span class="red--text" v-if="errors['banner']">{{ (errors['banner']) ? errors['banner'][0] : '' }}</span>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">

                            <v-text-field
                                label="Nombre *"
                                dense
                                outlined
                                :rules="[rules.required]"
                                v-model="data.name"
                                :error="(errors['name']) ? true : false"
                                :error-messages="(errors['name']) ? errors['name'][0] : ''"
                            ></v-text-field>


                            <v-text-field
                                v-if="typeStore == 'product'"
                                label="Nombre en tienda"
                                dense
                                outlined
                                v-model="data.store_show_name"
                                :error="(errors['store_show_name']) ? true : false"
                                :error-messages="(errors['store_show_name']) ? errors['store_show_name'][0] : ''"
                                placeholder="Opcional"
                            ></v-text-field>

                            <v-row>
                                <v-col cols="8">
                                    <v-text-field
                                        label="Código producto (opcional)"
                                        dense
                                        outlined
                                        v-model="data.code"
                                        text="barcode"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-btn
                                        @click="startScan('code')"
                                        color="primary"
                                        >
                                        <v-icon>mdi-barcode</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <v-row v-if="typeStore == 'product'">
                                <v-col cols="8">
                                    <v-text-field
                                        label="Código de barras (opcional)"
                                        dense
                                        outlined
                                        v-model="data.barcode"
                                        text="barcode"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-btn
                                        @click="startScan('barcode')"
                                        color="primary"
                                        >
                                        <v-icon>mdi-barcode</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <!-- add barcode -->
                            <template>
                                <div class="text-center pa-4">
                                    <!-- <v-btn @click="dialog = true">
                                        Open Dialog
                                    </v-btn> -->

                                    <v-dialog
                                        v-model="dialog"
                                        max-width="500"
                                        persistent
                                    >
                                        <v-card>
                                            <v-card-title class="text-h5 grey lighten-2">
                                                Escanear Código de barras.
                                            </v-card-title>

                                            <barcode
                                                @result="onScan"
                                                ref="barcodeRef"
                                                container="reader_product"
                                            ></barcode>

                                            <v-divider></v-divider>

                                            <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="primary"
                                                text
                                                @click="stopScan"
                                            >
                                                Cerrar
                                            </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </div>
                            </template>
                            <!-- end add barcode -->

                            <label for="">Descripción (opcional)</label>
                            <vue-editor v-model="data.description" :editor-toolbar="customToolbar" class="mb-6" />
                            <v-text-field
                                :label="`Precio ${money} *`"
                                dense
                                outlined
                                type="number"
                                :rules="[rules.required]"
                                v-model="data.price"
                                :error="(errors['price']) ? true : false"
                                :error-messages="(errors['price']) ? errors['price'][0] : ''"
                            ></v-text-field>
                            <v-text-field
                                :label="`Precio especial ${money} (opcional)`"
                                dense
                                outlined
                                type="number"
                                v-model="data.specialPrice"
                                :error="(errors['special_price']) ? true : false"
                                :error-messages="(errors['special_price']) ? errors['special_price'][0] : ''"
                            ></v-text-field>
                            <v-text-field
                                label="Stock vista tienda (opcional)"
                                dense
                                outlined
                                type="number"
                                min="0"
                                v-model="data.stock"
                                :error="(errors['stock']) ? true : false"
                                :error-messages="(errors['stock']) ? errors['stock'][0] : ''"
                            ></v-text-field>
                            <div>
                                <div class="text-h5 mb-4">Precios por mayor</div>
                                <v-simple-table dense>
                                    <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left">
                                                Cantidad mínima
                                            </th>
                                            <th class="text-left">
                                                Precio unitario
                                            </th>
                                            <th>Quitar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(pric, m) in data.wholesalePrices" :key="m">
                                            <td class="pa-2">
                                                <v-text-field
                                                    label="Cantidad *"
                                                    dense
                                                    outlined
                                                    type="number"
                                                    hide-details
                                                    :rules="[rules.required]"
                                                    v-model="pric.quantity"
                                                ></v-text-field>
                                            </td>
                                            <td class="pa-2">
                                                <v-text-field
                                                    label="precio *"
                                                    dense
                                                    outlined
                                                    type="number"
                                                    hide-details
                                                    :rules="[rules.required]"
                                                    v-model="pric.price"
                                                ></v-text-field>
                                            </td>
                                            <td class="text-right pa-2">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            icon
                                                            @click="()=>{data.wholesalePrices.splice(m, 1)}"
                                                        >
                                                            <v-icon color="grey">
                                                                mdi-delete
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Eliminar</span>
                                                </v-tooltip>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colspan="3" class="text-right pa-2">
                                                <v-btn
                                                    class="text-capitalize"
                                                    dark
                                                    small
                                                    @click="()=>{data.wholesalePrices.push({quantity: '', price: ''})}"
                                                >
                                                    Agregar
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </tfoot>
                                    </template>
                                </v-simple-table>
                            </div>
                            <div v-if="(+inventory)">
                                <div class="text-h5 mb-4"
                                    v-if="typeStore !== 'gastronomic'"
                                >Inventarios</div>
                                <v-text-field
                                    v-if="typeStore !== 'gastronomic'"
                                    label="costo unitario *"
                                    dense
                                    outlined
                                    type="number"
                                    :rules="[rules.required]"
                                    v-model="data.unitCost"
                                    :error="(errors['unit_cost']) ? true : false"
                                    :error-messages="(errors['unit_cost']) ? errors['unit_cost'][0] : ''"
                                ></v-text-field>
                                <div
                                    v-if="typeStore === 'gastronomic'"
                                >
                                    {{ data.unitCost }}
                                </div>
                                <v-text-field
                                    v-if="typeStore !== 'gastronomic'"
                                    label="stock Interno *"
                                    dense
                                    outlined
                                    type="number"
                                    min="0"
                                    :rules="[rules.required]"
                                    v-model="data.internalStock"
                                    :error="(errors['internal_stock']) ? true : false"
                                    :error-messages="(errors['internal_stock']) ? errors['internal_stock'][0] : ''"
                                ></v-text-field>
                            </div>

                            <!-- suplies -->

                            <div v-if="typeStore === 'gastronomic'">
                                <div class="text-h5 mb-4">
                                    Insumos
                                    <v-btn  fab x-small dark color="blue darken-1"
                                        type="button"
                                        title="Agregar insumo"
                                        @click="data.suplies.push({ no: itemSupliesCounter, code: '', quantity: 0 }); itemSupliesCounter+=1;"
                                    >
                                        <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                </div>


                                <div style="padding: 20px 0px;">
                                    <div v-if="data.suplies.length < 1">
                                        <b>Ningún insumo agregado</b>
                                    </div>

                                    <v-row v-for="(suply, s) in data.suplies" :key="s" >
                                        <v-col cols="6" style="padding: 0px 10px">
                                            <v-select
                                                :items="itemsSuplies"
                                                :item-text="supliesLabel"
                                                item-value="code"
                                                label="Insumo *"
                                                dense
                                                outlined
                                                v-model="suply.code"
                                                :rules="[
                                                    v => !!v || 'Required',
                                                ]"
                                                ></v-select>

                                        </v-col>
                                        <v-col cols="3" style="padding: 0px 10px">
                                            <v-text-field
                                                type="number"
                                                v-model="suply.quantity"
                                                label="Cantidad"
                                                controlVariant="split"
                                                step="any"
                                                min="0"
                                                outlined
                                                dense
                                                :rules="[
                                                    v => !!v || 'Required',
                                                    v => v >= 0 || 'Min 1'
                                                ]"
                                                >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="3" style="padding: 0px 10px">
                                            <v-btn  fab x-small dark color="red darken-1"
                                                type="button"
                                                title="Quitar insumo"
                                                @click="data.suplies = data.suplies.filter(sup => sup.no !== suply.no)"
                                            >
                                                <v-icon>mdi-minus</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </div>

                            </div>

                            <!-- end suplies -->
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                            <v-select
                                :items="itemsCategories"
                                item-text="name"
                                item-value="id"
                                label="Categorías *"
                                dense
                                outlined
                                multiple
                                :rules="[rules.required2]"
                                v-model="data.category"
                                :error="(errors['category_id']) ? true : false"
                                :error-messages="(errors['category_id']) ? errors['category_id'][0] : ''"
                            ></v-select>
                            <v-select
                                :items="itemsComplements"
                                item-text="title"
                                item-value="id"
                                label="Complementos"
                                outlined
                                v-model="data.complements"
                                multiple
                                chips
                                :rules="typeStore=='product' ? [rules.max] : []"
                                @change="selectComplement()"
                            ></v-select>

                            <!-- complementos extras -->
                            <div class="mb-4" v-if="typeStore == 'product'">
                                <div class="text-subtitle">Complementos combinados</div>
                                <v-divider class="mb-2"></v-divider>
                                <v-row no-gutters class="mb-2" align="center" v-for="(complement, k) in complementExtras" :key="k">
                                    <v-col cols="4">
                                        {{ complement.name }}
                                    </v-col>
                                    <v-col cols="8" class="text-right">
                                        <div class="d-flex align-center">
                                            <v-text-field
                                                label="Código de barras (opcional)"
                                                dense
                                                outlined
                                                v-model="complement.barcode"
                                                text="barcode"
                                                hide-details
                                            ></v-text-field>
                                            <v-btn
                                                @click="startScan('barcodecomplement', k)"
                                                color="primary"
                                                icon
                                                outlined
                                            >
                                                <v-icon>mdi-barcode</v-icon>
                                            </v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>

                            <!-- gallery -->
                            <div class="mb-4">
                                Galería <small>Máximo {{ maxImages }} imágenes</small>
                                <input type="file"
                                    accept="image/png,image/jpeg,image/jpg"
                                    ref="fileGallery"
                                    class="d-none"
                                    @change="previewImage"
                                >
                                <v-row no-gutters>
                                    <v-col
                                        cols="12"
                                        class="pa-1 pa-sm-2"
                                    >
                                        <v-btn @click="addNewImage" color="primary" :disabled="data.gallery.length >= maxImages">
                                            Añadir imagen <v-icon>mdi-image-plus</v-icon>
                                        </v-btn>
                                    </v-col>
                                    <v-col
                                        cols="2"
                                        class="pa-1 pa-sm-2"
                                        v-for="(url, index) in previewGallery" :key="index"
                                    >
                                        <v-img
                                            :src="(url!='')?url:'/images/overlay-img.png'"
                                            :lazy-src="(url!='')?url:'/images/overlay-img.png'"
                                            :aspect-ratio="1"
                                            color="grey lighten-2"
                                            class="text-right"
                                        >
                                            <v-btn v-if="url!=''" @click="removeImage(index)" fab x-small dark color="red darken-3">
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                        </v-img>
                                    </v-col>
                                </v-row>
                            </div>
                            <!-- gallery END -->
                        </v-col>

                        <!-- suplies -->
                        <!-- <v-col cols="12" sm="12" md="6">
                            <div>
                                <div class="text-h5 mb-4">Insumos</div>
                                <v-simple-table dense>
                                    <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left">
                                                Insumo
                                            </th>
                                            <th class="text-left">
                                                Cantidad
                                            </th>
                                            <th>Quitar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(sup, o) in data.suplies" :key="o">
                                            <td class="pa-2">
                                                <v-select
                                                    :items="itemsSuplies"
                                                    item-text="name"
                                                    item-value="id"
                                                    label="Insumo"
                                                    v-model="sup.suply_id"
                                                    style="height: 40px;"
                                                    outlined
                                                    dense
                                                ></v-select>
                                            </td>
                                            <td class="pa-2">
                                                <v-text-field
                                                    label="Cantidad *"
                                                    dense
                                                    outlined
                                                    type="number"
                                                    hide-details
                                                    :rules="[rules.required]"
                                                    v-model="sup.quantity"
                                                ></v-text-field>
                                            </td>
                                            <td class="text-right pa-2">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            icon
                                                            @click="()=>{data.suplies.splice(o, 1)}"
                                                        >
                                                            <v-icon color="grey">
                                                                mdi-delete
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Eliminar</span>
                                                </v-tooltip>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colspan="3" class="text-right pa-2">
                                                <v-btn
                                                    class="text-capitalize"
                                                    dark
                                                    small
                                                    @click="()=>{data.suplies.push({suply_id: '', quantity: ''})}"
                                                >
                                                    Agregar
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </tfoot>
                                    </template>
                                </v-simple-table>
                            </div>
                        </v-col> -->

                        <!-- información extra -->
                        <v-col cols="12">
                            <div class="text-h5">Información extra</div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-checkbox
                                v-model="data.extraBtn"
                                :value="true"
                                label="Añadir botón más información"
                            ></v-checkbox>
                            <v-radio-group
                                v-model="data.typeBtn"
                                column
                                v-if="data.extraBtn"
                            >
                                <v-radio
                                    label="Página URL externa"
                                    value="url"
                                ></v-radio>
                                <v-radio
                                    label="Página URL de video de Youtube"
                                    value="video"
                                ></v-radio>
                            </v-radio-group>
                            <v-text-field
                                v-if="data.extraBtn"
                                label="Texto del botón"
                                outlined
                                dense
                                v-model="data.textBtn"
                            ></v-text-field>
                            <v-text-field
                                v-if="data.typeBtn!=='' && data.extraBtn"
                                :label="data.typeBtn=='url'?'Página URL externa':'Código de video de Youtube'"
                                outlined
                                dense
                                v-model="data.urlBtn"
                            ></v-text-field>
                        </v-col>

                        <!-- promociones -->
                        <v-col cols="12">
                            <div class="text-h5">Promociones</div>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-dialog
                                ref="menu"
                                v-model="menu"
                                :return-value.sync="promo.dates"
                                persistent
                                width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-combobox
                                        v-model="promo.dates"
                                        multiple
                                        chips
                                        small-chips
                                        label="Fechas"
                                        append-icon="mdi-calendar"
                                        readonly
                                        outlined
                                        dense
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <template v-slot:append-outer>
                                            <v-btn
                                                small
                                                class="text-capitalize"
                                                dark
                                                @click="promo.dates=[]"
                                            >Limpiar fechas</v-btn>
                                        </template>
                                    </v-combobox>
                                </template>
                                <v-date-picker
                                    v-model="promo.dates"
                                    multiple
                                    scrollable
                                    locale="es-Bo"
                                    color="primary"
                                    class="ma-0"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="menu = false"
                                    >
                                        Cancelar
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        @click="$refs.menu.save(promo.dates)"
                                    >
                                        OK
                                    </v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-dialog
                                ref="menu2"
                                v-model="menu2"
                                :return-value.sync="promo.timeInit"
                                persistent
                                width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="promo.timeInit"
                                        label="Hora inicio"
                                        append-icon="mdi-clock-time-four-outline"
                                        readonly
                                        outlined
                                        dense
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-time-picker
                                    v-if="menu2"
                                    v-model="promo.timeInit"
                                    full-width
                                    color="primary"
                                    class="ma-0"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="menu2 = false"
                                    >
                                        Cancelar
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        @click="$refs.menu2.save(promo.timeInit)"
                                    >
                                        OK
                                    </v-btn>
                                </v-time-picker>
                            </v-dialog>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-dialog
                                ref="menu3"
                                v-model="menu3"
                                :return-value.sync="promo.timeEnd"
                                persistent
                                width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="promo.timeEnd"
                                        label="Hora fin"
                                        append-icon="mdi-clock-time-four-outline"
                                        readonly
                                        outlined
                                        dense
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-time-picker
                                    v-if="menu3"
                                    v-model="promo.timeEnd"
                                    full-width
                                    color="primary"
                                    class="ma-0"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="menu3 = false"
                                    >
                                        Cancelar
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        @click="$refs.menu3.save(promo.timeEnd)"
                                    >
                                        OK
                                    </v-btn>
                                </v-time-picker>
                            </v-dialog>
                        </v-col>

                        <v-col cols="12" sm="12" class="text-center">
                            <v-btn type="submit" color="primary" :loading="loading">
                                Registrar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
import draggable from 'vuedraggable'
export default {
    components: {
        draggable,
    },
    data() {
        return {
            overlay: false,
            loading: false,
            breadcrumbs: [
                {
                    text: 'Productos/Servicios',
                    disabled: false,
                    href: '/admin/products',
                },
                {
                    text: 'Crear producto',
                    disabled: true,
                    href: '',
                }
            ],
            dialogAdd: false,
            tmpId: null,
            itemsCategories: [],
            itemsComplements: [],
            previewImg: '',
            itemSupliesCounter: 0,
            itemsSuplies: [],
            data: {
                code: '',
                barcode: '',
                name: '',
                store_show_name: '',
                description: '',
                category: [],
                complements: [],
                banner: null,
                price: '',
                specialPrice: '',
                stock: '',
                unitCost: '',
                internalStock: '',
                gallery: [],
                wholesalePrices: [],
                // extra
                extraBtn: false,
                typeBtn: '',
                textBtn: '',
                urlBtn: '',
                // insumos
                suplies: [],
            },
            typeScan: 'code',
            indexComplement: null,
            complementExtras: [],
            // gallery
            previewGallery: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
            maxImages: 15,
            // promotions
            menu: false,
            menu2: false,
            menu3: false,
            promo: {
                dates: [],
                timeInit: '',
                timeEnd: ''
            },
            // form validate
            rules: {
                required: value => !!value || 'Campo obligatorio.',
                required2: value => value.length > 0 || 'Campo obligatorio.',
                size: value => !value || value.size < 7000000 || '¡El tamaño de la foto debe ser inferior a 2 MB!',
                max: value => value.length <= 2 || '¡No puedes agregar más de 2 complementos!',
            },
            errors: {},
            // editor
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline"],
                [{ align: "" }, { align: "center" }, { align: "right"}, { align: "justify"}],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ color: [] }]
            ],
            dialog: false
        }
    },
    props: ['inventory', 'typeStore', 'money'],
    created() {
        this.getCategories();
        this.getComplements();
        this.getSuplies();
    },
    methods: {
        // gallery
        addNewImage() {
            this.$refs.fileGallery.click();
        },
        previewImage (event) {
            const file = event.target.files[0]
            const fileType = file.type
            if (fileType == 'image/jpeg' || fileType == 'image/jpg' || fileType == 'image/png') {
                this.data.gallery.push(file)
                this.previewGallery[this.data.gallery.length - 1] = URL.createObjectURL(file)
            } else {
                this.$notify.warning('Formato no permitido.');
                return
            }
        },
        removeImage(i) {
            this.previewGallery.splice(i, 1)
            this.previewGallery.push('')
            this.data.gallery.splice(i, 1)
        },
        // end Gallery
        async getCategories() {
            await axios.post('/admin/list-categories', {})
            .then(response => {
                this.itemsCategories = response.data;
            })
            .catch(error => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        async getComplements() {
            await axios.post('/admin/list-complements')
            .then((response) => {
                // console.log(response)
                this.itemsComplements = response.data
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        supliesLabel(suply) {
            return `${suply.name} (${suply.unit_measure})`;
        },
        async getSuplies() {
            await axios.get('/admin/suplies')
            .then((response) => {
                // console.log(response)
                this.itemsSuplies = response.data.suplies
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        // create product
        openInputFile() {
            this.$refs.fileInput.click();
        },
        upBanner(event) {
            const file = event.target.files[0];
            this.previewImg = URL.createObjectURL(file);
            this.data.banner = file;
        },
        // *************************** register ***************************//
        async formRegister() {
            if (this.$refs.refAddProduct.validate()) {
                // if (this.listProd.length > 0) {
                    this.loading = true
                    this.errors = {};
                    const formData = new FormData();
                    formData.append('code', this.data.code);
                    formData.append('barcode', this.data.barcode);
                    formData.append('name', this.data.name);
                    formData.append('store_show_name', (this.typeStore === "product")? this.data.store_show_name : "");
                    formData.append('description', this.data.description);
                    formData.append('banner', this.data.banner);
                    formData.append('categories', JSON.stringify(this.data.category));
                    formData.append('price', this.data.price);
                    formData.append('special_price', (this.data.specialPrice!='')?this.data.specialPrice:'none');
                    formData.append('stock', this.data.stock);
                    formData.append('internal_stock', this.data.internalStock);
                    formData.append('unit_cost', this.data.unitCost);
                    formData.append('complements', JSON.stringify(this.data.complements));
                    for (let i = 0; i < this.data.gallery.length; i++) {
                        formData.append(`gallery[${i}]`, this.data.gallery[i]);
                    }
                    // promotion
                    formData.append('promo_dates', JSON.stringify(this.promo.dates))
                    formData.append('promo_init', this.promo.timeInit)
                    formData.append('promo_end', this.promo.timeEnd)

                    formData.append('type', 'page')

                    // extra button
                    formData.append('btn_extra', this.data.extraBtn?1:0)
                    formData.append('text_btn_extra', this.data.textBtn)
                    formData.append('type_btn_extra', this.data.typeBtn)
                    formData.append('url_btn_extra', this.data.urlBtn)

                    // precios por mayor
                    formData.append('wholesale_prices', JSON.stringify(this.data.wholesalePrices))

                    // insumos
                    formData.append('suplies', JSON.stringify(this.data.suplies))

                    // complementos extras
                    formData.append('complements_extra', JSON.stringify(this.complementExtras))

                    await axios.post('/admin/new-product', formData)
                    .then(response => {
                        // console.log(response);
                        if (response.data === 'ok') {
                            this.$alert('', 'Producto registrado con éxito.', 'success', {confirmButtonText: 'Continuar'})
                            this.previewImg = ''
                            this.previewGallery = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '']
                            this.data.name = ''
                            this.data.code = ''
                            this.data.barcode = ''
                            this.data.description = ''
                            this.data.category = ''
                            this.data.complements = []
                            this.data.banner = null
                            this.data.price = ''
                            this.data.specialPrice = ''
                            this.data.stock = null
                            this.data.gallery = []
                            this.data.extraBtn = false
                            this.data.textBtn = ''
                            this.data.typeBtn = ''
                            this.data.urlBtn = ''
                            this.data.internalStock = ''
                            this.data.unitCost = ''
                            this.$refs.refAddProduct.resetValidation()
                            this.data.suplies = []
                            this.complementExtras = []
                            // this.$refs.refAddProduct.reset()
                        }

                        this.loading = false
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            this.errors = error.response.data.errors
                        }
                        if (error.response.status == 404 || error.response.status == 500) {
                            this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                        }
                        this.loading = false
                    })
                // } else {
                //     this.$notify.info("Debe registrar al menos un producto.");
                // }
            }
        },
        onScan (decodedText, decodedResult) {
            if (this.typeScan == 'code') {
                this.data.code = decodedText;
            }
            if (this.typeScan == 'barcode') {
                this.data.barcode = decodedText;
            }
            if (this.typeScan == 'barcodecomplement') {
                this.complementExtras[this.indexComplement].barcode = decodedText
            }
            this.stopScan();
        },
        startScan(type, i=0) {
            this.typeScan = type
            this.indexComplement = i
            this.$refs.barcodeRef?.start();
            this.dialog = true;
        },
        stopScan () {
            this.$refs.barcodeRef?.stop();
            this.dialog = false;
        },

        /**
         * complementos extras
         */
        permutations(matriz, index = 0, current = [], ids = [], names = [], result = []) {
            if (index === matriz.length) {
                result.push({
                    name: current.join("-"),
                    names: names,
                    price: '',
                    barcode: '',
                    ids: ids
                }); // Unir los valores en una cadena
                return;
            }

            for (let num of matriz[index]) {
                this.permutations(matriz, index + 1, [...current, num[1]], [...ids, num[0]], [...names, num[1]], result);
            }

            return result;
        },
        selectComplement() {
            this.complementExtras = [];
            let tmpcomplementExtras = [];
            if (this.typeStore == 'product') {
                if (this.data.complements.length > 0) {
                    tmpcomplementExtras = this.itemsComplements.filter(complement => {
                        if (this.data.complements.includes(complement.id)) {
                            return complement
                        }
                    })
                }
            }

            let matriz = [];
            if (tmpcomplementExtras.length > 0) {
                tmpcomplementExtras.forEach(element => {
                    matriz.push(JSON.parse(element.values).map(item => [element.id, item.name]));
                });
            }

            this.complementExtras = this.permutations(matriz);
        }
    },
}
</script>
<style lang="scss">
.list-group-item {
    border-bottom: 1px solid #e0e0e0;
}
</style>
